import ServiceService from '@/services/ServiceService'

export default {
  namespaced: true,

  state: {
    isFetching: false,
    service: {}
  },

  getters: {},

  mutations: {
    set (state, service) {
      state.service = service
    },

    setIsFetching (state, isFetching) {
      state.isFetching = isFetching
    }
  },

  actions: {
    get ({ commit }, serviceId) {
      commit('setIsFetching', true)

      return ServiceService.get(serviceId)
        .then(service => {
          commit('set', service)
          commit('setIsFetching', false)
          return service
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/service.js